/* eslint-disable no-bitwise */
export enum UserFlag3 {
  OneTimePINRequired = 1 << 24,
  AMLVerified = 1 << (35 - 32),
  AMLDocsInProgress = 1 << (36 - 32),
  AMLSuspended = 1 << (37 - 32),
  AMLDepositThresholdReached = 1 << (38 - 32),
  AMLShowVerifiedModal = 1 << (40 - 32),
  KYCRequired = 1 << (46 - 32),
  VerifiedForMarketing = 1 << (47 - 32),
  VulnerablePlayer = 1 << (50 - 32),
  LicenseMobileVerified = 1 << 16
}
